import { TruckIcon } from "@heroicons/react/24/outline";
import ChecklistItem from "./ChecklistItem";
import { Vehicle } from "../../data/productionLineMock";

type Props = {
  vehicle: Vehicle;
  showChecklist: boolean;
};

export default function VehicleCard({ vehicle, showChecklist }: Props) {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm ring-1 ring-gray-200 dark:ring-gray-800 p-3">
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-gray-900 dark:text-gray-100 leading-tight truncate">
            {vehicle.name}
          </div>
          <div className="mt-0.5 text-xs text-gray-600 dark:text-gray-300 leading-tight truncate">
            <span className="text-gray-500">Reg: </span>{vehicle.registration}
          </div>
          <div className="mt-1 text-xs text-gray-600 dark:text-gray-300 leading-tight">
            <div className="truncate"><span className="text-gray-500">Ref: </span>{vehicle.reference}</div>
            <div className="truncate mt-0.5"><span className="text-gray-500">Colour: </span>{vehicle.colour}</div>
          </div>
        </div>
        <div className="shrink-0">
          {vehicle.imageUrl ? (
            <img
              src={vehicle.imageUrl}
              alt={vehicle.name}
              className="h-10 w-16 rounded-md object-contain bg-gray-100 dark:bg-gray-800"
            />
          ) : (
            <div className="h-10 w-16 rounded-md bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
              <TruckIcon className="h-6 w-6 text-gray-500" />
            </div>
          )}
        </div>
      </div>

      {showChecklist && vehicle.checklist && vehicle.checklist.length > 0 && (
        <div className="mt-2 pt-2 border-t border-gray-100 dark:border-gray-800">
          <ul className="space-y-1.5">
            {vehicle.checklist.map((item) => (
              <ChecklistItem key={item.id} item={item} />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}


